/* __next_internal_client_entry_do_not_use__ EventsThemeShapeCombination auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from "@faire/web--source/slate/Layout";
import { EventsThemeShape } from "@faire/web--source/slate/Theme/EventsThemeShape";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import React from "react";
import styled, { css } from "styled-components";
var EventThemeCombinationBase = function(param) {
    var frontShape = param.frontShape, backShape = param.backShape, height = param.height, width = param.width, className = param.className;
    var FrontShape = frontShape.component;
    var BackShape = backShape.component;
    var _frontShape_height;
    return /*#__PURE__*/ _jsxs(Container, {
        height: height,
        width: width,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(ShapeWrapper, {
                $right: backShape.right,
                children: /*#__PURE__*/ _jsx(BackShape, {
                    height: backShape.height,
                    color: backShape.color,
                    style: {
                        display: "block"
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ShapeWrapper, {
                $right: frontShape.right,
                $bottom: frontShape.bottom,
                children: /*#__PURE__*/ _jsx(FrontShape, {
                    height: (_frontShape_height = frontShape.height) !== null && _frontShape_height !== void 0 ? _frontShape_height : height,
                    color: frontShape.color,
                    style: {
                        display: "block"
                    }
                })
            })
        ]
    });
};
var ComboAShapeCombination = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 375;
    var defaultHeight = 193;
    var defaultFrontShapeHeight = 150;
    var defaultBackShapeHeight = 175;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    var widthPx = !width || isNaN(parseInt(width)) ? defaultWidth : parseInt(width);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape.faireMarket.tertiary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor,
            right: widthPx / 2.193
        },
        backShape: {
            component: EventsThemeShape.faireMarket.secondary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor,
            right: widthPx / 6.818
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboAShapeCombinationFwm23 = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 375;
    var defaultHeight = 193;
    var defaultFrontShapeHeight = 150;
    var defaultBackShapeHeight = 175;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    var widthPx = !width || isNaN(parseInt(width)) ? defaultWidth : parseInt(width);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_WINTER_MARKET_2023].primary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor,
            right: widthPx / 5
        },
        backShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_WINTER_MARKET_2023].secondary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboAShapeCombinationFsm22 = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 245;
    var defaultHeight = 130;
    var defaultFrontShapeHeight = 130;
    var defaultBackShapeHeight = 77;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    var widthPx = !width || isNaN(parseInt(width)) ? defaultWidth : parseInt(width);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].primary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor
        },
        backShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].secondary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor,
            right: widthPx / 3
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboBShapeCombination = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 308;
    var defaultHeight = 194;
    var defaultFrontShapeHeight = 119;
    var defaultBackShapeHeight = 194;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    var widthPx = !width || isNaN(parseInt(width)) ? defaultWidth : parseInt(width);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape.faireMarket.secondary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor,
            right: widthPx / 2.962,
            bottom: heightPx / 6.69
        },
        backShape: {
            component: EventsThemeShape.faireMarket.tertiary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboBShapeCombinationFwm23 = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 308;
    var defaultHeight = 194;
    var defaultFrontShapeHeight = 175;
    var defaultBackShapeHeight = 194;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_WINTER_MARKET_2023].secondary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor
        },
        backShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_WINTER_MARKET_2023].tertiary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboBShapeCombinationFsm22 = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 308;
    var defaultHeight = 194;
    var defaultFrontShapeHeight = 175;
    var defaultBackShapeHeight = 194;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].secondary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor
        },
        backShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].tertiary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboCShapeCombination = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 308;
    var defaultHeight = 194;
    var defaultFrontShapeHeight = 150;
    var defaultBackShapeHeight = 194;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    var widthPx = !width || isNaN(parseInt(width)) ? defaultWidth : parseInt(width);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape.faireMarket.primary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor,
            right: widthPx / 4.529
        },
        backShape: {
            component: EventsThemeShape.faireMarket.tertiary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboCShapeCombinationFwm23 = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 308;
    var defaultHeight = 194;
    var defaultFrontShapeHeight = 150;
    var defaultBackShapeHeight = 194;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_WINTER_MARKET_2023].primary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor
        },
        backShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_WINTER_MARKET_2023].tertiary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
var ComboCShapeCombinationFsm22 = function(param) {
    var height = param.height, width = param.width, frontShapeColor = param.frontShapeColor, backShapeColor = param.backShapeColor, className = param.className;
    var defaultWidth = 308;
    var defaultHeight = 194;
    var defaultFrontShapeHeight = 150;
    var defaultBackShapeHeight = 194;
    var heightPx = !height || isNaN(parseInt(height)) ? defaultHeight : parseInt(height);
    return /*#__PURE__*/ _jsx(EventThemeCombinationBase, {
        frontShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].primary,
            height: "".concat(defaultFrontShapeHeight / defaultHeight * heightPx, "px"),
            color: frontShapeColor
        },
        backShape: {
            component: EventsThemeShape[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].tertiary,
            height: "".concat(defaultBackShapeHeight / defaultHeight * heightPx, "px"),
            color: backShapeColor
        },
        height: height !== null && height !== void 0 ? height : "".concat(defaultHeight, "px"),
        width: width !== null && width !== void 0 ? width : "".concat(defaultWidth, "px"),
        className: className
    });
};
export var EventsThemeShapeCombination = {
    faireMarket: {
        comboA: ComboAShapeCombination,
        comboB: ComboBShapeCombination,
        comboC: ComboCShapeCombination
    },
    FAIRE_WINTER_MARKET_2023: {
        comboA: ComboAShapeCombinationFwm23,
        comboB: ComboBShapeCombinationFwm23,
        comboC: ComboCShapeCombinationFwm23
    },
    FAIRE_SUMMER_MARKET_2022: {
        comboA: ComboAShapeCombinationFsm22,
        comboB: ComboBShapeCombinationFsm22,
        comboC: ComboCShapeCombinationFsm22
    }
};
var Container = styled(Row).withConfig({
    componentId: "sc-94a3c1dd-0"
})([
    "",
    " position:relative;"
], function(props) {
    return css([
        "height:",
        ";width:",
        ";"
    ], props.height, props.width);
});
var ShapeWrapper = styled.div.withConfig({
    componentId: "sc-94a3c1dd-1"
})([
    "position:absolute;right:",
    "px;bottom:",
    "px;"
], function(param) {
    var $right = param.$right;
    return $right !== null && $right !== void 0 ? $right : 0;
}, function(param) {
    var $bottom = param.$bottom;
    return $bottom !== null && $bottom !== void 0 ? $bottom : 0;
});
